import styled from "styled-components";

export const PlayerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const PlayerStatus = styled.div`
  ${({ theme: { colors } }) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    background: ${colors("text", 0.1)};

    &.waiting {
      opacity: 0.6;
    }

    &.correct {
      background: ${colors("success", 0.2)};
      color: ${colors("success")};
    }

    &.incorrect {
      background: ${colors("danger", 0.2)};
      color: ${colors("danger")};
    }
  `}
`;
